// assets/custom.js
document.addEventListener('DOMContentLoaded', function () {
  console.log('[custom.js] cargado');

  function addMobileMenuItems() {
    // Solo mobile (< 992px)
    if (!window.matchMedia('(max-width: 991px)').matches) {
      return false;
    }

    var menu =
      document.querySelector('#menuMobile .menu-mobile') ||
      document.querySelector('.mobile-layer .menu-mobile');

    if (!menu) {
      // menú aún no existe
      return false;
    }

    // Evitar duplicados
    if (menu.dataset.extraItemsAdded === '1') {
      return true;
    }

    var blogLink = menu.querySelector('a[href="/blogs/tu-salud"]');
    if (!blogLink) {
      console.log('[custom.js] link Blog no encontrado en menú');
      return false;
    }

    var blogLi = blogLink.closest('li');
    if (!blogLi) return false;

    // 3 items ANTES de "Blog"
    blogLi.insertAdjacentHTML('beforebegin', `
      <li class="menu-mobile-link extra-mobile-item">
        <a href="/collections/all">Productos</a>
      </li>
      <li class="menu-mobile-link extra-mobile-item">
        <a href="/collections/promociones-y-paquetes">Ofertas</a>
      </li>
      <li class="menu-mobile-link extra-mobile-item">
        <a href="/blogs/tu-salud">Padecimientos</a>
      </li>
    `);

    // 2 items DESPUÉS de "Blog"
    blogLi.insertAdjacentHTML('afterend', `
      <li class="menu-mobile-link extra-mobile-item">
        <a href="/account">Mi cuenta</a>
      </li>
      <li class="menu-mobile-link extra-mobile-item">
        <a href="/cart">Carrito</a>
      </li>
    `);

    menu.dataset.extraItemsAdded = '1';
    console.log('[custom.js] Items extra agregados al menú mobile');
    return true;
  }

  // Intento directo al cargar (por si el menú ya existe)
  addMobileMenuItems();

  // Click en hamburguesa -> hacemos polling hasta que aparezca el menú
  var toggles = document.querySelectorAll('a.nav--mobile[data-dialog-trigger="#menuMobile"]');
  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var attempts = 0;
      var maxAttempts = 20; // 20 * 100ms = 2 segundos

      var intervalId = setInterval(function () {
        attempts++;
        if (addMobileMenuItems()) {
          clearInterval(intervalId);
        } else if (attempts >= maxAttempts) {
          console.log('[custom.js] No se encontró el menú después de varios intentos');
          clearInterval(intervalId);
        }
      }, 100);
    });
  });

  // Por si el theme recarga secciones
  document.addEventListener('shopify:section:load', addMobileMenuItems);
  document.addEventListener('shopify:section:select', addMobileMenuItems);
});
